export default {"src":"/_next/static/media/unidex.29d556df.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};